import {
    Card,
    CardBody,
    CardHeader,
    Divider,
    Progress,
    Spacer,
    Image,
    Modal,
    Button,
    ModalFooter,
    ModalBody, Input, ModalContent, ModalHeader, Dropdown, DropdownTrigger, DropdownMenu, DropdownItem
} from "@heroui/react";
import CustomSwitch from "../CustomSwitch";
import React, {useEffect, useState} from "react";
import axios from "axios";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";
import {ChevronDownIcon, Ship} from "lucide-react";
import { Icon } from "@iconify/react";
import {format} from "date-fns";
import { toZonedTime } from "date-fns-tz";
import {FaFileExcel, FaFilePdf, FaFileWord} from "react-icons/fa";
import DownloadZipButton from "../DownloadZipButton";
import {apiClient} from "../../services/apiClient";

//VISTA CORRESPONDIENTE AL CARRIER (PUBLIC)
export default ({rskRef, code, onTitleLoaded}) => {
    const filesEndpoint = `${process.env.REACT_APP_API_URL}/carrier/attachment/`;
    const [selectedFile, setSelectedFile] = useState(null); //archivo a visializar modal documentos
    const [isFileModalOpen, setIsFileModalOpen] = useState(false); // modal documentos
    const [surveyData, setSurveyData] = useState(undefined);
    //LightBox
    const [selectedImage, setSelectedImage] = useState(null);
    const [open, setOpen] = useState(false);
    //./LightBox

    const handleImageClick = (imageUrl) => {
        setSelectedImage(imageUrl);
        setOpen(true);
    };

    useEffect(() => {
        const fetchClaims = async () => {
            try {
                const response = await apiClient.get(`/carrier/claimsurvey?ref=${rskRef}&code=${code}`);
                console.log('response', response)
                setSurveyData(response.data);
                //console.log(response.data)
                
                // Enviar el título al componente padre cuando se carguen los datos
                if (onTitleLoaded && response.data?.quickview_claim) {
                    const title = `${response.data.quickview_claim.rsk_ref?.replace(/\//g, "-")} / ${response.data.quickview_claim.exporter_name} / ${response.data.quickview_claim.vessel} / ${response.data.quickview_claim.bl_awb} / ${response.data.quickview_claim.container_number}`;
                    onTitleLoaded(title);
                }
            } catch (error) {
                console.error("Error al obtener los datos:", error);
            }
        };
        fetchClaims();
    }, [rskRef, code, onTitleLoaded]);

    const headerFields = [
        { icon: "lucide:hash", label: "Claim Number", value: surveyData?.quickview_claim.rsk_ref},
        { icon: "lucide:shopping-basket", label: "Exporter", value: surveyData?.quickview_claim.exporter_name },
        { icon: "lucide:shopping-cart", label: "Product", value: surveyData?.maestra.especie },
        { icon: "lucide:container", label: "Container Number", value: surveyData?.quickview_claim.container_number },
        { icon: "lucide:ship-wheel", label: "Port of Loading (POL)", value: surveyData?.quickview_claim.pol },
        { icon: "lucide:ship-wheel", label: "Port of Discharge (POD)", value: surveyData?.quickview_claim.pod },
        { icon: "lucide:ship", label: "Vessel Name", value: surveyData?.quickview_claim.vessel },
        { icon: "lucide:receipt-text", label: "Bill of Lading (B/L) Number", value: surveyData?.quickview_claim.bl_awb },
        { icon: "lucide:user", label: "Carrier", value: surveyData?.quickview_claim.carrier_name },
        { icon: "lucide:calendar", label: "ETA", 
            value: surveyData?.quickview_claim?.eta 
                ? format(toZonedTime(new Date(surveyData.quickview_claim.eta), "UTC"), "dd-MM-yyyy")
                : "N/A"
        },
        { icon: "lucide:calendar", label: "ATA", 
            value: surveyData?.quickview_claim?.ata 
                ? format(toZonedTime(new Date(surveyData.quickview_claim.ata), "UTC"), "dd-MM-yyyy")
                : "N/A"
        },
        { icon: "lucide:hash", label: "Causa", value: surveyData?.maestra?.causa || "N/A" }
    ]

    const perdidaCalculadaConsignment = [
        { icon: "lucide:dollar-sign", label: "Sound Market Value (SMV)",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.consign_sound_market_value || 0)
        },
        {
            icon: "lucide:dollar-sign", icon2: "lucide:minus", label: "Actual Sales Value",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.consign_actual_sales_value || 0)
        },
        { icon: "lucide:dollar-sign", icon2: "lucide:equal", label: "Loss Due to Damage",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.consign_loss_due_damage || 0)
        },
        {
            icon: "lucide:dollar-sign",
            icon2: "lucide:plus",
            label: "Extra Costs Incurred (if any)",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(
                    surveyData?.extra_costs?.reduce((total, item) => {
                        // Verifica si item.value existe y conviértelo a número
                        const value = parseFloat(item.value) || 0;
                        return total + value;
                    }, 0) || 0
                ),
            hasDropdown: surveyData?.extra_costs?.length > 0 // Determina si debe mostrar un dropdown

        },
        { icon: "lucide:dollar-sign", icon2: "lucide:equal", label: "Claim Amount",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.claimamount || 0)
        },
    ];

    const perdidaCalculadaFirm = [
        { icon: "lucide:dollar-sign", label: "Invoice Value",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.firm_invoice_value || 0)},
        {
            icon: "lucide:dollar-sign",
            icon2: "lucide:minus",
            label: "Sales",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.firm_sales || 0),
            // Solo incluir si firm_sales tiene un valor válido (no 0, null, undefined o vacío)
            show: surveyData?.quickview_claim_survey.firm_sales != null
        },
        {
            icon: "lucide:dollar-sign",
            label: "Credit Note",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.firm_credit_note || 0),
            // Solo incluir si firm_credit_note tiene un valor válido (no 0, null, undefined o vacío)
            show: surveyData?.quickview_claim_survey.firm_credit_note != null
        },
        { icon: "lucide:dollar-sign", icon2: "lucide:plus", label: "Freight",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.firm_freight || 0)},
        { icon: "lucide:dollar-sign", icon2: "lucide:equal", label: "Loss Due Damage",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.firm_loss_due_damage || 0)},
        { icon: "lucide:dollar-sign", icon2: "lucide:plus", label: "Destruction if Apply",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.firm_destruction_if_apply || 0)},
        {
            icon: "lucide:dollar-sign",
            icon2: "lucide:plus",
            label: "Other Extra Expenses",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(
                    surveyData?.extra_costs?.reduce((total, item) => {
                        // Verifica si item.value existe y conviértelo a número
                        const value = parseFloat(item.value) || 0;
                        return total + value;
                    }, 0) || 0
                ),
            hasDropdown: surveyData?.extra_costs?.length > 0 // Determina si debe mostrar un dropdown

        },

        { icon: "lucide:dollar-sign", icon2: "lucide:equal", label: "Claim Amount",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.claimamount || 0)
        },
    ].filter(field => field.show !== false); // Filtrar los campos que no tienen `show: false`

    const insurancePayment = [

        { icon: "lucide:dollar-sign", label: "Insurance Payment",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.insurancepayment || 0)},
        { icon: "lucide:dollar-sign", label: "Deductible",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.deductible || 0)},
        { icon: "lucide:dollar-sign", label: "Not Covered",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.not_covered || 0)},
        { icon: "lucide:dollar-sign", icon2: "lucide:equal", label: "Claim Amount",
            value: new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                .format(surveyData?.quickview_claim_survey.claimamount || 0)
        },

    ]

    const shippingDocuments = [

        { title: "BL/AWB", value: surveyData?.quickview_claim_survey.blawb },
        { title: "Packing List", value: surveyData?.quickview_claim_survey.packinglist},
        { title: "Phyto Certificate", value: surveyData?.quickview_claim_survey.phytocertificate},
        { title: "DUS/DUA", value: surveyData?.quickview_claim_survey.dusdua},
        { title: "Invoice", value: surveyData?.quickview_claim_survey.invoice},
        { title: "Origin Certificate", value: surveyData?.quickview_claim_survey.origincertificate},
        { title: "Booking", value: surveyData?.quickview_claim_survey.booking},
        { title: "Booking with ETA", value: surveyData?.quickview_claim_survey.bookingtwitheta}

    ];

    const supportingEvidence = [

        { title: "Harvest Report", value: surveyData?.quickview_claim_survey.harvestreport },
        { title: "QC at reception", value: surveyData?.quickview_claim_survey.qcatreception },
        { title: "QC for finish product", value: surveyData?.quickview_claim_survey.qcforfinishproduct },
        { title: "Loading/Shipping Instructions", value: surveyData?.quickview_claim_survey.loadingshippinginstructions },
        { title: "Stuffing Report", value: surveyData?.quickview_claim_survey.stuffingreport },
        { title: "Stuffing Report with pictures", value: surveyData?.quickview_claim_survey.stuffingreportwithpictures }

    ]

    const salesResults = [

        { title: "Sales results", value: surveyData?.quickview_claim_survey.salesresults },
        { title: "Proof of Sales (local invoices)", value: surveyData?.quickview_claim_survey.proofofsaleslocalinvoices },
        { title: "Extra expenses with support", value: surveyData?.quickview_claim_survey.extraexpenseswithsupport },
        { title: "Market Prices", value: surveyData?.quickview_claim_survey.marketprices },
        { title: "Credit Note", value: surveyData?.quickview_claim_survey.creditnote },
        { title: "Destruction Certificate", value: surveyData?.quickview_claim_survey.destructioncertificate },
        { title: "Sales Agreement", value: surveyData?.quickview_claim_survey.salesagreement },
        { title: "IVV", value: surveyData?.quickview_claim_survey.ivv },

    ]

    const claimingDocuments = [

        { title: "Notice of Claim", value: surveyData?.quickview_claim_survey.noticeofclaim },
        { title: "QC at Destination", value: surveyData?.quickview_claim_survey.qcatdestination },
        { title: "Survey Inspection", value: surveyData?.quickview_claim_survey.surveyinspection },
        { title: "Loss Calculation", value: surveyData?.quickview_claim_survey.losscalculation },
        { title: "LOA (exporter/insurer)", value: surveyData?.quickview_claim_survey.loaexporterinsurer },
        { title: "AOR (consignee)", value: surveyData?.quickview_claim_survey.aorconsignee },
        { title: "Value Protect (Maersk)", value: surveyData?.quickview_claim_survey.valueprotectmaersk },

    ]

    //modal documentos
    const openFileModal = (file) => {
        setSelectedFile(file);
        setIsFileModalOpen(true);
    };
    const closeFileModal = () => {
        setIsFileModalOpen(false);
        setSelectedFile(null);
    };

    return (
        <>
            {/* Condicional para mostrar contenido según el estado de surveyData */}
            {surveyData === undefined ? (
                // Mostrar spinner si surveyData es undefined
                // <Spinner color="primary" label="Cargando..." labelColor="primary" />
                <>
                <p>Cargando...</p>
                <Progress isIndeterminate aria-label="Cargando..." className="max-w-full" size="sm" />
                </>
            ) : surveyData === null ? (
                // Mostrar mensaje si surveyData es null
                <p>No hay datos disponibles.</p>
            ) : (

                <div>
                    {/*HEADER*/}
                    <div className="max-w-full">
                    {/*<div className="p-4 max-w-full mx-auto">*/}
                        <Card className="w-full">
                            <CardBody>
                                <h2 className="text-2xl font-bold">{surveyData?.quickview_claim.rsk_ref?.replace(/\//g, "-")} / {surveyData?.quickview_claim.exporter_name} / {surveyData?.quickview_claim.vessel} / {surveyData?.quickview_claim.bl_awb} / {surveyData?.quickview_claim.container_number}</h2>
                                <Divider className="my-4" />
                                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
                                    {headerFields.map((field, index) => (
                                        <div key={index} className="w-full">
                                            <Input
                                                isReadOnly
                                                label={field.label}
                                                value={field.value}
                                                startContent={
                                                    <Icon
                                                        icon={field.icon}
                                                        className="text-default-400 pointer-events-none flex-shrink-0"
                                                    />
                                                }
                                                classNames={{
                                                    label: "text-sm font-medium",
                                                    input: "text-sm"
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </CardBody>
                        </Card>
                    </div>

                    <Spacer />

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">

                        <Card className="max-w-[400px]">
                            <CardHeader className="flex gap-3 justify-center">
                                <div className="flex flex-col">
                                    <p className="text-md">Shipping Documents</p>
                                </div>
                            </CardHeader>
                            <Divider />
                            <CardBody className="gap-1">

                                {
                                    shippingDocuments
                                        .filter(field => field.value !== undefined)
                                        .map((field, index) => (
                                            <CustomSwitch key={index} title={field.title} data={field.value} />
                                        ))
                                }

                            </CardBody>
                        </Card>

                        <Card className="max-w-[400px]">
                            <CardHeader className="flex gap-3 justify-center">
                                <div className="flex flex-col">
                                    <p className="text-md">Supporting Evidence</p>
                                    {/*<p className="text-small text-default-500">heroui.com</p>*/}
                                </div>
                            </CardHeader>
                            <Divider />
                            <CardBody className="gap-1">

                                {
                                    supportingEvidence
                                        .filter(field => field.value !== undefined)
                                        .map((field, index) => (
                                            <CustomSwitch key={index} title={field.title} data={field.value} />
                                        ))
                                }

                            </CardBody>
                        </Card>

                        <Card className="max-w-[400px]">
                            <CardHeader className="flex gap-3 justify-center">
                                <div className="flex flex-col">
                                    <p className="text-md">Sales Results</p>
                                    {/*<p className="text-small text-default-500">heroui.com</p>*/}
                                </div>
                            </CardHeader>
                            <Divider />
                            <CardBody className="gap-1">

                                {
                                    salesResults
                                        .filter(field => field.value !== undefined)
                                        .map((field, index) => (
                                            <CustomSwitch key={index} title={field.title} data={field.value} />
                                        ))
                                }

                            </CardBody>
                        </Card>

                        <Card className="max-w-[400px]">
                            <CardHeader className="flex gap-3 justify-center">
                                <div className="flex flex-col">
                                    <p className="text-md">Claiming Documents</p>
                                    {/*<p className="text-small text-default-500">heroui.com</p>*/}
                                </div>
                            </CardHeader>
                            <Divider />
                            <CardBody className="gap-1">

                                {
                                    claimingDocuments
                                        .filter(field => field.value !== undefined)
                                        .map((field, index) => (
                                            <CustomSwitch key={index} title={field.title} data={field.value} />
                                        ))
                                }

                            </CardBody>
                        </Card>

                    </div>

                    <Spacer />

                    {/* PERDIDA INSURANCE PAYMENT */}
                    {
                        surveyData?.quickview_claim_survey.insurancepayment != null && surveyData?.quickview_claim_survey.insurancepayment !== "" &&
                        surveyData?.quickview_claim_survey.deductible != null && surveyData?.quickview_claim_survey.deductible !== "" &&
                        surveyData?.quickview_claim_survey.not_covered != null && surveyData?.quickview_claim_survey.not_covered !== ""

                        && (
                            <>
                                <div className="max-w-full mx-auto">
                                    <Card className="w-full">
                                        <CardBody>
                                            <h2 className="text-2xl font-bold">
                                                Insurance payment
                                            </h2>
                                            <Divider className="my-4" />
                                            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
                                                { insurancePayment.map((field, index) => (
                                                    <div key={index} className="w-full">
                                                        <Input
                                                            isReadOnly
                                                            label={field.label}
                                                            value={field.value}
                                                            startContent={
                                                                <>
                                                                    {field.icon2 && (
                                                                        <Icon
                                                                            icon={field.icon2}
                                                                            className="text-primary-500 pointer-events-none flex-shrink-0"
                                                                        />
                                                                    )}
                                                                    <Icon
                                                                        icon={field.icon}
                                                                        className="text-default-400 pointer-events-none flex-shrink-0"
                                                                    />
                                                                </>
                                                            }
                                                            classNames={{
                                                                label: "text-sm font-medium",
                                                                input: "text-sm"
                                                            }}
                                                        />
                                                    </div>
                                                ))
                                                }
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                                <Spacer />
                            </>
                        )}

                    {/*CALCULO DE FREE CONSIGNMENT*/}
                    {(surveyData?.quickview_claim_survey.insurancepayment == null || surveyData?.quickview_claim_survey.insurancepayment === "") &&
                        (surveyData?.quickview_claim_survey.deductible == null || surveyData?.quickview_claim_survey.deductible === "") &&
                        (surveyData?.quickview_claim_survey.not_covered == null || surveyData?.quickview_claim_survey.not_covered === "") &&
                        surveyData?.quickview_claim_survey.selected_calculation === "consignment" && (
                            <>
                                <div className="max-w-full mx-auto">
                                    <Card className="w-full">
                                        <CardBody>
                                            <h2 className="text-2xl font-bold">Loss Calculation: Free Consignment</h2>
                                            <Divider className="my-4" />
                                            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
                                                {perdidaCalculadaConsignment.map((field, index) => (
                                                    <div key={index} className="w-full relative">
                                                        {field.hasDropdown ? (
                                                            <Dropdown
                                                                classNames={{
                                                                    base: "bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700",
                                                                    content: "p-2 min-w-[300px] max-h-[300px] overflow-y-auto",
                                                                }}
                                                            >
                                                                <DropdownTrigger>
                                                                    <Input
                                                                        isReadOnly
                                                                        label={field.label}
                                                                        value={field.value}
                                                                        endContent={
                                                                            <ChevronDownIcon className="w-5 h-5 text-gray-500" />
                                                                        }
                                                                        startContent={
                                                                            <>
                                                                                {field.icon2 && (
                                                                                    <Icon
                                                                                        icon={field.icon2}
                                                                                        className="text-primary-500 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                                    />
                                                                                )}
                                                                                <Icon
                                                                                    icon={field.icon}
                                                                                    className="text-default-400 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                                />
                                                                            </>
                                                                        }
                                                                        classNames={{
                                                                            inputWrapper:
                                                                                "group-data-[hover=true]:border-primary-500 group-data-[focus=true]:border-primary-500 cursor-pointer transition-all duration-200 bg-gray-50 dark:bg-gray-900 border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-800",
                                                                            label: "text-sm font-medium text-gray-700 dark:text-gray-200",
                                                                            input: "text-sm text-gray-900 dark:text-gray-100",
                                                                            innerWrapper: "items-center",
                                                                        }}
                                                                        description={field.hasDropdown ? "Click to view details" : undefined}
                                                                    />
                                                                </DropdownTrigger>
                                                                <DropdownMenu
                                                                    aria-label="Extra Costs Details"
                                                                    classNames={{
                                                                        base: "p-2",
                                                                        list: "space-y-1",
                                                                    }}
                                                                >
                                                                    {surveyData.extra_costs.map((cost, idx) => (
                                                                        <DropdownItem
                                                                            key={idx}
                                                                            textValue={`${cost.name}: ${cost.value}`}
                                                                            classNames={{
                                                                                base: "rounded-md hover:bg-primary-50 dark:hover:bg-primary-900 transition-colors",
                                                                                title: "text-gray-900 dark:text-gray-100",
                                                                            }}
                                                                        >
                                                                            <div className="flex justify-between items-center py-1">
                                                                                <span className="text-sm font-medium">{cost.name}</span>
                                                                                <span className="text-sm text-gray-600 dark:text-gray-400">
                                      {new Intl.NumberFormat("es-CL", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                      }).format(parseFloat(cost.value) || 0)}
                                    </span>
                                                                            </div>
                                                                        </DropdownItem>
                                                                    ))}
                                                                </DropdownMenu>
                                                            </Dropdown>
                                                        ) : (
                                                            <Input
                                                                isReadOnly
                                                                label={field.label}
                                                                value={field.value}
                                                                startContent={
                                                                    <>
                                                                        {field.icon2 && (
                                                                            <Icon
                                                                                icon={field.icon2}
                                                                                className="text-primary-500 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                            />
                                                                        )}
                                                                        <Icon
                                                                            icon={field.icon}
                                                                            className="text-default-400 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                        />
                                                                    </>
                                                                }
                                                                classNames={{
                                                                    inputWrapper:
                                                                        "bg-gray-50 dark:bg-gray-900 border-gray-300 dark:border-gray-600",
                                                                    label: "text-sm font-medium text-gray-700 dark:text-gray-200",
                                                                    input: "text-sm text-gray-900 dark:text-gray-100",
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                                <Spacer />
                            </>
                    )}

                    {/*PERDIDA CALCULADA FIRM*/}
                    {
                        (surveyData?.quickview_claim_survey.insurancepayment == null || surveyData?.quickview_claim_survey.insurancepayment == "") &&
                        (surveyData?.quickview_claim_survey.deductible == null || surveyData?.quickview_claim_survey.deductible == "") &&
                        (surveyData?.quickview_claim_survey.not_covered == null || surveyData?.quickview_claim_survey.not_covered == "") &&
                        surveyData.quickview_claim_survey.selected_calculation === "firm"
                        && (
                            <>
                                <div className="max-w-full mx-auto">
                                    <Card className="w-full">
                                        <CardBody>
                                            <h2 className="text-2xl font-bold">Loss Calculation: Firm</h2>
                                            <Divider className="my-4" />
                                            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
                                                {perdidaCalculadaFirm.map((field, index) => (
                                                    <div key={index} className="w-full relative">
                                                        {field.hasDropdown ? (
                                                            <Dropdown
                                                                classNames={{
                                                                    base: "bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700",
                                                                    content: "p-2 min-w-[300px] max-h-[300px] overflow-y-auto",
                                                                }}
                                                            >
                                                                <DropdownTrigger>
                                                                    <Input
                                                                        isReadOnly
                                                                        label={field.label}
                                                                        value={field.value}
                                                                        endContent={
                                                                            <ChevronDownIcon className="w-5 h-5 text-gray-500" />
                                                                        }
                                                                        startContent={
                                                                            <>
                                                                                {field.icon2 && (
                                                                                    <Icon
                                                                                        icon={field.icon2}
                                                                                        className="text-primary-500 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                                    />
                                                                                )}
                                                                                <Icon
                                                                                    icon={field.icon}
                                                                                    className="text-default-400 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                                />
                                                                            </>
                                                                        }
                                                                        classNames={{
                                                                            inputWrapper:
                                                                                "group-data-[hover=true]:border-primary-500 group-data-[focus=true]:border-primary-500 cursor-pointer transition-all duration-200 bg-gray-50 dark:bg-gray-900 border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-800",
                                                                            label: "text-sm font-medium text-gray-700 dark:text-gray-200",
                                                                            input: "text-sm text-gray-900 dark:text-gray-100",
                                                                            innerWrapper: "items-center",
                                                                        }}
                                                                        description={field.hasDropdown ? "Click to view details" : undefined}
                                                                    />
                                                                </DropdownTrigger>
                                                                <DropdownMenu
                                                                    aria-label="Extra Costs Details"
                                                                    classNames={{
                                                                        base: "p-2",
                                                                        list: "space-y-1",
                                                                    }}
                                                                >
                                                                    {surveyData.extra_costs.map((cost, idx) => (
                                                                        <DropdownItem
                                                                            key={idx}
                                                                            textValue={`${cost.name}: ${cost.value}`}
                                                                            classNames={{
                                                                                base: "rounded-md hover:bg-primary-50 dark:hover:bg-primary-900 transition-colors",
                                                                                title: "text-gray-900 dark:text-gray-100",
                                                                            }}
                                                                        >
                                                                            <div className="flex justify-between items-center py-1">
                                                                                <span className="text-sm font-medium">{cost.name}</span>
                                                                                <span className="text-sm text-gray-600 dark:text-gray-400">
                                                                                  {new Intl.NumberFormat("es-CL", {
                                                                                      minimumFractionDigits: 2,
                                                                                      maximumFractionDigits: 2,
                                                                                  }).format(parseFloat(cost.value) || 0)}
                                                                                </span>
                                                                            </div>
                                                                        </DropdownItem>
                                                                    ))}
                                                                </DropdownMenu>
                                                            </Dropdown>
                                                        ) : (
                                                            <Input
                                                                isReadOnly
                                                                label={field.label}
                                                                value={field.value}
                                                                startContent={
                                                                    <>
                                                                        {field.icon2 && (
                                                                            <Icon
                                                                                icon={field.icon2}
                                                                                className="text-primary-500 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                            />
                                                                        )}
                                                                        <Icon
                                                                            icon={field.icon}
                                                                            className="text-default-400 pointer-events-none flex-shrink-0 w-5 h-5"
                                                                        />
                                                                    </>
                                                                }
                                                                classNames={{
                                                                    inputWrapper:
                                                                        "bg-gray-50 dark:bg-gray-900 border-gray-300 dark:border-gray-600",
                                                                    label: "text-sm font-medium text-gray-700 dark:text-gray-200",
                                                                    input: "text-sm text-gray-900 dark:text-gray-100",
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                                <Spacer />
                            </>
                    )}

                    <Card className="w-full">
                        <CardBody>
                            <h2 className="text-2xl font-bold">Supporting Documents</h2>
                            <Divider className="my-2" />
                            <h4 className="mt-4 mb-3 font-bold">Documents</h4>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                {surveyData.attachments &&
                                surveyData.attachments.filter(file => !file.mimetype?.startsWith('image/')).length > 0 ? (
                                    surveyData.attachments
                                        .filter(file => !file.mimetype?.startsWith('image/') && file.visible !== false) // Filtra archivos que NO sean imágenes y estén visibles
                                        .map((file, index) => {
                                            const isPDF = file.mimetype === 'application/pdf';
                                            const isWord =
                                                file.mimetype === 'application/msword' ||
                                                file.mimetype === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                                            const isExcel =
                                                file.mimetype === 'application/vnd.ms-excel' ||
                                                file.mimetype === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

                                            return (
                                                <div
                                                    key={file.id || index}
                                                    className="flex flex-col items-center text-center cursor-pointer"
                                                    onClick={() => openFileModal(file)}
                                                >
                                                    {isPDF ? (
                                                        <FaFilePdf size={100} className="text-red-600" />
                                                    ) : isWord ? (
                                                        <FaFileWord size={100} className="text-blue-600" />
                                                    ) : isExcel ? (
                                                        <FaFileExcel size={100} className="text-green-600" />
                                                    ) : (
                                                        <p className="text-gray-500">Unsupported format</p>
                                                    )}
                                                    <div className="mt-2">
                                                        <p>
                                                            <strong>
                                                                {file.filename
                                                                    ? file.filename.split('-').slice(5).join('-')
                                                                    : 'Sin nombre'}
                                                            </strong>
                                                        </p>
                                                        {/* <p className="text-sm text-gray-600">
                                                            Peso: {(file.archivo_peso / 1024).toFixed(2)} KB
                                                        </p> */}
                                                    </div>
                                                </div>
                                            );
                                        })
                                ) : (
                                    <p>No documents available.</p>
                                )}
                            </div>

                            <h4 className="mt-4 mb-3 font-bold">Images</h4>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                {surveyData.attachments && surveyData.attachments.filter(file => file.mimetype?.startsWith('image/')).length > 0 ? (
                                    surveyData.attachments
                                        .filter((file) => file.mimetype?.startsWith('image/') && file.visible !== false)
                                        .map((image, index) => (
                                            <Image
                                                key={index} // Clave única para React
                                                isZoomed
                                                isBlurred
                                                alt={`Attachment Image ${index + 1}`}
                                                src={`${filesEndpoint}${image.filename}?thumb=true&code=${code}`}
                                                height={200}
                                                className="cursor-pointer"
                                                onClick={() => handleImageClick(`${image.filename}`)}
                                            />
                                        ))
                                ) : (
                                    <p>No images available.</p>
                                )}
                            </div>

                            <Spacer />

                            <div className="flex justify-end mt-4">
                                <DownloadZipButton files={surveyData?.attachments} endpoint={filesEndpoint} fileName={surveyData?.maestra.rsk_ref} code={code}/>
                            </div>

                        </CardBody>
                    </Card>

                    {/* Lightbox para mostrar imagen en alta calidad */}
                    <Lightbox
                        open={open}
                        close={() => setOpen(false)}
                        slides={selectedImage ? [{ src: `${filesEndpoint}${selectedImage}`, downloadFilename: `${selectedImage.split('/').pop()}` }] : []}
                        carousel={{ finite: true }}
                        controller={{ close: true, prev: false, next: false }}
                        plugins={[Zoom, Download]}
                    />

                </div> //div contenido
            )}

            {/* Modal interno para previsualización */}
            {isFileModalOpen && (
                <Modal
                    isOpen={isFileModalOpen}
                    onClose={closeFileModal}
                    size="5xl"
                    className="max-h-[90vh] overflow-y-auto"
                >
                    <ModalContent>
                        {() => (
                            <>
                                <ModalHeader className="flex flex-col gap-1">
                                    {/*{selectedFile?.filename || selectedFile?.filename || 'Sin nombre'}*/}
                                    {selectedFile?.filename
                                    ? selectedFile.filename.split('-').slice(5).join('-')
                                    : 'Untitled'}
                                </ModalHeader>
                                <ModalBody>
                                    {selectedFile && (
                                        <>
                                            {/*<p>Peso: {((selectedFile.archivo_peso || selectedFile.imagen_peso || 0) / 1024).toFixed(2)} KB</p>*/}
                                            <p>Format: {selectedFile.mimetype || 'unknown'}</p>
                                            <div className="mt-4">
                                                {(selectedFile.mimetype?.startsWith('image/') || !selectedFile.mimetype) ? (
                                                    <img
                                                        src={`${filesEndpoint}${selectedFile.archivo_ruta || selectedFile.imagen_ruta}?code=${code}`}
                                                        alt={selectedFile.filename || selectedFile.filename}
                                                        className="max-w-full h-auto"
                                                    />
                                                ) : selectedFile.mimetype === 'application/pdf' ? (
                                                    <iframe
                                                        src={`${filesEndpoint}${selectedFile.filename}?code=${code}`}
                                                        title={selectedFile.filename}
                                                        className="w-full h-[60vh]"
                                                    />
                                                ) : (
                                                    (selectedFile.mimetype === 'application/msword' ||
                                                        selectedFile.mimetype === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                                                        selectedFile.mimetype === 'application/vnd.ms-excel' ||
                                                        selectedFile.mimetype === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                                                        selectedFile.mimetype === 'application/x-zip-compressed') ? (
                                                        <p>
                                                            File download:{' '}
                                                            <a
                                                                href={`${filesEndpoint}${selectedFile.filename}?code=${code}`}
                                                                className="text-blue-500"
                                                                download
                                                            >
                                                                Download
                                                            </a>
                                                        </p>
                                                    ) : (
                                                        <p>
                                                            File preview not supported. File download:{' '}
                                                            <a
                                                                href={`${filesEndpoint}${selectedFile.filename}?code=${code}`}
                                                                className="text-blue-500"
                                                                download
                                                            >
                                                                Download
                                                            </a>
                                                        </p>
                                                    )
                                                )}
                                            </div>
                                        </>
                                    )}
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" variant="light" onPress={closeFileModal}>
                                        Close
                                    </Button>
                                </ModalFooter>
                            </>
                        )}
                    </ModalContent>
                </Modal>
            )}

        </>
    );
}